import { Component, OnInit } from "@angular/core";
import { ModalRef } from "mis-design-system/mis-modal";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";

@Component({
  selector: "mis-employee-web-exp-recurrence-confirmation",
  templateUrl: "./recurrence-confirmation.component.html",
  styleUrls: ["./recurrence-confirmation.component.scss"]
})
export class RecurrenceConfirmationComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  constructor(private modalRef: ModalRef) {}

  ngOnInit(): void {}
  cancel(): void {
    this.modalRef.close();
  }
  confirm(): void {
    this.modalRef.close(true);
  }
}
